var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('unauthorizedIcon'),_c('p',{staticClass:"title"},[_vm._v("Error 401 - unauthorized")]),_c('p',{staticClass:"description"},[_vm._v("You don't have permission to view this page using the credentials provided.")]),_c('b-button',{attrs:{"variant":"link","href":"/"}},[_vm._v("Refresh page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }